module.exports = __webpack_public_path__ + "img/asca-name.57a74e88.svg";